import * as actionTypes from "./actionTypes";
import jwt_decode from "jwt-decode";
import axios from "../../axios-amps";

export const setAuthorizationToken = (token) => {
  axios.defaults.headers.common["accessToken"] = `${token}`;
};

export const parseAccessTokenSuccess = () => {
  return {
    type: actionTypes.PARSE_ACCESS_TOKEN_SUCCESS,
  };
};
export const parseAccessTokenFailed = (error) => {
  return {
    type: actionTypes.PARSE_ACCESS_TOKEN_FAILED,
    payload: error,
  };
};
export const parseAccessTokenStarted = () => {
  return {
    type: actionTypes.PARSE_ACCESS_TOKEN_STARTED,
  };
};
export const parseAccessToken = () => {
  return (dispatch) => {
    dispatch(parseAccessTokenStarted());
    return new Promise((resolve, reject) => {
      resolve(parsingAccessToken());
    }).then(() => {
      console.log("parseAccessTokenSuccess");
      dispatch(parseAccessTokenSuccess());
    });
  };
};
export const parsingAccessToken = () => {
  // const token = sessionStorage.getItem(`${process.env.REACT_APP_ACCESS_TOKEN}`);
  const token = sessionStorage.getItem(`token`);
  const decoded = jwt_decode(token);
  const userId = decoded.userId;
  const clientId = decoded.clientId;
  const clientName = decoded.clientName;
  const idletimeout = decoded.idletimeout;
  const modulesConfig = decoded.config;

  // localStorage.setItem("token", token!);
  localStorage.setItem("userId", userId);
  localStorage.setItem("clientId", clientId);
  localStorage.setItem("clientName", clientName);
  localStorage.setItem("idletimeout", idletimeout);
  localStorage.setItem("modulesConfig", modulesConfig);

  // instance.defaults, { headers: { authorization: "foo bar" } };
  console.log("token", token);
  console.log("userId", userId);
  console.log("clientId", clientId);
  console.log("clientName", clientName);
  console.log("idletimeout", localStorage.getItem("idletimeout"));
  console.log("modulesConfig", modulesConfig);
  // setAuthorizationToken(localStorage.getItem("token"));
  // Object.assign(axios.instance.defaults, {headers: {authorization: 'foo bar'}});
};
